import { render } from "./WhitelistedCTA.vue?vue&type=template&id=173d2c1b"
import script from "./WhitelistedCTA.vue?vue&type=script&lang=js"
export * from "./WhitelistedCTA.vue?vue&type=script&lang=js"

import "./WhitelistedCTA.vue?vue&type=style&index=0&id=173d2c1b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__